// Lib
import { createAction } from 'redux-actions';

export const SubscriptionLoading = createAction('SUBSCRIPTION_LOADING');
export const SubscriptionLoaded = createAction('SUBSCRIPTION_LOADED');
